var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"card-title"},[_vm._l((_vm.sentence.characters),function(ch){return [(ch.ruby)?_c('ruby',[_vm._v("\n      "+_vm._s(ch.base)+" "),_c('rp',[_vm._v("(")]),_c('rt',[_vm._v(_vm._s(ch.ruby))]),_c('rp',[_vm._v(")")])]):_c('span',[_vm._v(_vm._s(ch.base))])]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6b5557e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/greetings/Sentence.vue
// module id = 70
// module chunks = 0